import initAutosize from '../helpers/autosize.js';
import initDatepicker from '../helpers/datepicker.js';
import initSelect2 from '../helpers/select2.js';
import { addNewPrototype, getAddressInfo, getUserInfo, removePrototype, updateOptionsSelect2 } from '../helpers/helper.js';

const initAfterSalesReportForm = () => {
	if(!$('#after-sales-add-edit-container').length){
		return;
	}

	const addressSelect = $('#after-sales-add-edit-container [data-function="address-handler"]');
	const titleSelect = $('[data-function="after-sales-title-handler"]');
	const userSelect = $('[data-function="user-handler"]');
	const contactPerson = $('[data-id="contact_person"]');
	const contactPerson2 = $('[data-id="contact_person_2"]');
	const addressEmail = $('[data-id="address_email"]');
	let addressData = null;
	let maintenanceInfo = null;
	let maintenanceEmailWasApplied = false;

	const emptyContactOptions = () => [{id: '', text: '=== auswählen ==='}];

	const updateContactOptions = (contacts) => {
		const options = emptyContactOptions();
		contacts.forEach((contact) => {
			options.push({id: contact.full_name, text: contact.full_name});
		});

		[contactPerson, contactPerson2].forEach((field) => {
			const currentValue = field.val();
			if(currentValue && !options.some((option) => option.id === currentValue)){
				options.push({id: currentValue, text: currentValue});
			}
			updateOptionsSelect2(field, options);
			field.val(currentValue).trigger('change.select2');
		});
	};

	const clearAddressFields = () => {
		addressData = null;
		maintenanceInfo = null;
		maintenanceEmailWasApplied = false;
		contactPerson.val('');
		contactPerson2.val('');
		updateContactOptions([]);
		[contactPerson, contactPerson2].forEach((field) => field.prop('disabled', false));
		$('[data-id="contact_person_email"], [data-id="contact_person_phone"], [data-id="contact_person_2_email"], [data-id="contact_person_2_phone"]').prop('disabled', false);
	};

	const findContact = (value) => {
		if(!addressData || !Array.isArray(addressData.contacts)){
			return null;
		}

		return addressData.contacts.find((contact) => contact.full_name === value) || null;
	};

	const bindContactHandler = (field, emailField, phoneField) => {
		field.off('change.after-sales-contact').on('change.after-sales-contact', function(){
			const contact = findContact($(this).val());
			if(!contact){
				return;
			}

			emailField.val(contact.email || '');
			phoneField.val(contact.phone || '');
		});
	};

	const applyMaintenanceProducts = () => {
		if(titleSelect.val() !== 'maintenance' || !maintenanceInfo || !Array.isArray(maintenanceInfo.devices)){
			return;
		}

		$('.after-sales-product-select').each(function(){
			const field = $(this);
			const currentValue = field.val();
			const options = [{id: '', text: '=== auswählen ==='}];
			maintenanceInfo.devices.forEach((device) => {
				const text = device.lot_serial ? `${device.product} (${device.lot_serial})` : device.product;
				options.push({id: device.product, text});
			});
			if(currentValue && !options.some((option) => option.id === currentValue)){
				options.push({id: currentValue, text: currentValue});
			}
			updateOptionsSelect2(field, options);
			field.val(currentValue).trigger('change.select2');
		});
	};

	const loadMaintenanceInfo = (addressId, initial = false) => {
		if(titleSelect.val() !== 'maintenance'){
			maintenanceInfo = null;
			return;
		}

		axios.get(`/api/after-sales/address/${addressId}/maintenance-info`)
			.then((response) => {
				maintenanceInfo = response.data;
				if((!initial || !addressEmail.data('manual')) && !addressEmail.val()){
					addressEmail.val(maintenanceInfo.email_maintenance || '');
					maintenanceEmailWasApplied = true;
				}
				applyMaintenanceProducts();
			});
	};

	const loadAddress = (value, initial = false) => {
		if(value === null || value === undefined || !/^\d+$/.test(value.toString())){
			clearAddressFields();
			return;
		}

		getAddressInfo(value, (data) => {
			addressData = data;
			updateContactOptions(data.contacts || []);
			loadMaintenanceInfo(value, initial);
		});
	};

	addressSelect.off('change.after-sales-address').on('change.after-sales-address', function(){
		addressEmail.val('').data('manual', false);
		maintenanceEmailWasApplied = false;
		$('[data-id="contact_person_email"], [data-id="contact_person_phone"], [data-id="contact_person_2_email"], [data-id="contact_person_2_phone"]').val('');
		loadAddress($(this).val());
	});

	titleSelect.off('change.after-sales-title').on('change.after-sales-title', function(){
		maintenanceInfo = null;
		if($(this).val() !== 'maintenance' && maintenanceEmailWasApplied){
			addressEmail.val('');
			maintenanceEmailWasApplied = false;
		}
		if($(this).val() === 'maintenance' && /^\d+$/.test((addressSelect.val() || '').toString())){
			loadMaintenanceInfo(addressSelect.val());
		}
	});

	addressEmail.off('input.after-sales-address-email').on('input.after-sales-address-email', () => {
		addressEmail.data('manual', true);
		maintenanceEmailWasApplied = false;
	});
	bindContactHandler(contactPerson, $('[data-id="contact_person_email"]'), $('[data-id="contact_person_phone"]'));
	bindContactHandler(contactPerson2, $('[data-id="contact_person_2_email"]'), $('[data-id="contact_person_2_phone"]'));

	userSelect.off('change.after-sales-user').on('change.after-sales-user', function(){
		const value = $(this).val();
		$('[data-id="user_email"], [data-id="user_phone"]').val('');
		if(value === null || value === undefined || !/^\d+$/.test(value.toString())){
			return;
		}
		getUserInfo(value, (data) => {
			if(data.id){
				$('[data-id="user_email"]').val(data.email);
				$('[data-id="user_phone"]').val(data.phone);
			}
		});
	});

	addNewPrototype('add-new-prototype-after-sales-product', () => {
		initSelect2();
		applyMaintenanceProducts();
	});

	$(document).off('click.after-sales-activity', '[data-function="add-new-after-sales-activity"]');
	$(document).on('click.after-sales-activity', '[data-function="add-new-after-sales-activity"]', function(){
		const target = $(this).data('target');
		const prototypeHolder = $(`[data-prototype-name="${target}"]`);
		if(!prototypeHolder.length){
			return;
		}
		const prototypeHtml = prototypeHolder.data('prototype-html');
		const uuid = parseInt(Math.random() * Math.floor(9899) + 100);
		prototypeHolder.before(prototypeHtml.replace(/__NAME__/g, uuid));
		const container = prototypeHolder.prev();
		container.find('[data-id="type"]').val($(this).data('type'));
		container.find('[data-id="info_text"]').text($(this).data('text') || '');
		initAutosize();
		initDatepicker();
		removePrototype();
	});

	if(addressSelect.val()){
		loadAddress(addressSelect.val(), true);
	}
};

export default initAfterSalesReportForm;
